<template>
	<section v-if="!magSelected">
		<div class="text-center mb-6">
			<div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-md p-4 max-w-2xl mx-auto border border-blue-100">
				<div class="flex items-center justify-center">
					<svg class="w-12 h-12 text-blue-600 mr-4" fill="currentColor" viewBox="0 0 24 24">
						<path d="M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z"/>
					</svg>
					<p class="text-2xl text-gray-700 font-semibold">Kliknutím označ, který časopis chceš vyhledat.</p>
				</div>
			</div>
		</div>
	</section>

	<!-- Časopisy grid -->
	<section class="mb-12 fade-in">
		<div class="flex flex-col space-y-6 md:grid md:gap-6 md:space-y-0 md:justify-items-center mx-auto"
			 :class="gridClass" >
			<div class="text-center mx-auto" v-for="title in titles" :key="title.id">
				<div class="relative">
					<div class="magazine-cover bg-gradient-to-br flex items-center justify-center shadow-lg">
						<img :src="title.url" @click="mag=title.mag" style="max-width:  320px; max-height: 408px;"/>
					</div>
					<!-- Červené kolečko s kříkem v pravém horním rohu titulky -->
					<div v-if="magSelected" class="close-button bg-red-500 rounded-full w-10 h-10 flex items-center justify-center absolute -top-2 -right-2 redCross" 
						@click="mag='';">
						<svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
							<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
						</svg>
					</div>
					<div class="mt-4">
						<a :href="'https://'+title.web" target="_blank" class="inline-flex items-center text-gray-600 hover:text-red-600 hover:underline transition-colors text-xl">
							<svg class="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
								<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
							</svg>
							{{title.web}}
						</a>
					</div>
				</div>
			</div>
			<div v-if="magSelected" class="text-center mx-auto">
				<!-- Formulář vpravo -->
				<div class="flex flex-col justify-between" style="max-width:  320px; max-height: 408px;">
					<!-- Text s ikonou -->
					<div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-md p-4 border border-blue-100" style="margin-bottom: 10px;">
						<div class="flex items-center">
							<svg class="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 24 24">
								<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
							</svg>
							<p class="text-gray-700 font-semibold">Zadej PSČ, kde hledáš časopis.</p>
						</div>
					</div>

					<!-- Vyhledávací pole -->
					<div style="margin-bottom: 10px;">
						<vendor-zip rest-api="./api/plugins/esprit/zipcodes/suggest" :size="32" :tabindex="10"
							placeholder="Zadej PSČ (např. 110 00)" :suggest-empty="true" :focus="true" v-model="zip" :params="mag" mode="pick"
						/>
					</div>

					<!-- Tlačítko Hledej -->
					<button v-if="zipSelected" @click="showVendors" tabindex="20" class="search-button w-full bg-gradient-to-r from-green-500 to-green-600 text-white font-bold py-4 px-8 rounded-lg text-xl shadow-lg hover:from-green-600 hover:to-green-700">
						<svg class="w-6 h-6 inline mr-2" fill="currentColor" viewBox="0 0 24 24">
							<path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
						</svg>
						Hledej
					</button>
					
					<div v-show="isError" class="bg-white rounded-xl shadow-md p-6 max-w-4xl mx-auto inline-block" style="margin-top: 20px;">
						<p class="text-red-700 leading-relaxed text-lg">{{errorMessage}}</p>
					</div>
				</div>
			</div>	
		</div>
	</section>
</template>

<script setup lang="ts">
	import { ref, computed, watch } from 'vue';
	import VendorZip from './VendorZip.vue';
	
	const props = defineProps({
		endpoint: String,
		onlyMag: String,
		lastMag: String,
		siteKey: String
		//lastZip: String,
	});
	
	const errorMessage = ref("");
	
	const mag = ref(props.lastMag);
	if (props.onlyMag) {
		mag.value=props.onlyMag;
	}
	const zip = ref("");
	//const zip = ref(props.lastZip);
	const allTitles = ref([]);	
			
	const emit = defineEmits(['showVendors']);
	
	const isError = computed(() => {
		return  errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});
	
	const titles = computed<[]>(() => {
		if (!magSelected.value) return allTitles.value;
		return allTitles.value.filter((title) => title.mag===mag.value);
	});
	
	const selectedTitle = computed(() => {
		return titles.value[0];
	});
			
	const magSelected = computed<boolean>(() => {
		return mag.value!=="";
	});
	
	const zipSelected = computed<boolean>(() => {
		return zip.value!=="";
	});

	const selectEnabled = computed<boolean>(() => {
		return props.onlyMag?false:true;
	});
	
	
	const gridClass = computed<String>(() => {
		return magSelected.value?"md:grid-cols-2 max-w-2xl":"md:grid-cols-3 max-w-5xl";
	});
		
	watch(mag, (newMag: string) => {
		//zip.value="";
		zip.value="";
	});
	
	function showVendors(): void {
		//console.log("siteKey:"+props.siteKey);
		grecaptcha.ready(() => {
			grecaptcha.execute(props.siteKey, { action: 'submitFilter' }).then((token) => {
				//console.log('reCAPTCHA v3 token:', token);
				fetchGet("./api/plugins/esprit/vendors?mag="+mag.value+"&zip="+zip.value+"&token="+token)
				.then(data => {
					//check recaptcha TODO
					if (data.vendors) {
						emit('showVendors',data.vendors, mag.value, zip.value);
					}
				});
			});
		  });
	}
	
	function fetchGet(url: string) {
		//console.log("Fetching url:"+url);
		errorMessage.value = "";
		return fetch(url)
			.then(response => {
				if (response.status === 429) {
					errorMessage.value = 'Příliš mnoho požadavků, zkuste to znovu později.';
					console.log("error status:"+response.status);
					return;
				}
				return response.json();
			})
			//.then(response => response.json())
			.then(data => {
				//console.log("Loaded data:"+JSON.stringify(data));
				return data;
			})
			.catch((error) => {
				console.log("error :"+error);
			});
	}
		
	//on created
	fetchGet("./api/plugins/esprit/lists?list=titles")
		.then(data => {
			allTitles.value=data.items;
		});
	
</script>
